import { Info, CheckCircle } from "lucide-react";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

const TransparencySection = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.2 });

  return (
    <section className="py-12 md:py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div ref={ref} className="max-w-3xl mx-auto">
          <div className={`bg-background border-2 border-primary/20 rounded-2xl p-6 md:p-10 transition-all duration-700 ${isVisible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
            <div className="flex items-start gap-3 mb-5">
              <div className={`w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0 transition-all duration-500 ${isVisible ? 'opacity-100 rotate-0' : 'opacity-0 -rotate-12'}`} style={{ transitionDelay: '200ms' }}>
                <Info className="w-5 h-5 text-primary" />
              </div>
              <div className={`transition-all duration-500 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4'}`} style={{ transitionDelay: '300ms' }}>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-1">
                  Transparence & Cadre légal
                </h2>
                <p className="text-muted-foreground text-sm">
                  Pour une collaboration en toute clarté
                </p>
              </div>
            </div>

            <div className={`bg-primary/5 border-2 border-primary/40 rounded-xl p-4 mb-5 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`} style={{ transitionDelay: '400ms' }}>
              <div className="flex items-center gap-2 mb-3">
                <div className="w-8 h-8 rounded-lg bg-primary/30 flex items-center justify-center flex-shrink-0">
                  <Info className="w-5 h-5 text-primary" />
                </div>
                <p className="text-base md:text-lg font-bold text-primary">GoBledPro n'est pas un transporteur</p>
              </div>
              <div className="space-y-2 pl-2">
                <div className="flex items-start gap-2">
                  <span className="text-primary font-bold">→</span>
                  <p className="text-sm md:text-base text-foreground font-medium">Nous facilitons la mise en relation clients / transporteurs</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-primary font-bold">→</span>
                  <p className="text-sm md:text-base text-foreground font-medium">Transport assuré par des professionnels indépendants</p>
                </div>
                <div className="flex items-start gap-2">
                  <span className="text-primary font-bold">→</span>
                  <p className="text-sm md:text-base text-foreground font-medium">Chaque transporteur est responsable de sa prestation</p>
                </div>
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-3">
              {[
                "Transporteurs professionnels indépendants",
                "Mise en relation simplifiée",
                "Données protégées (RGPD)",
                "Service transparent et clair",
              ].map((text, index) => (
                <div 
                  key={index}
                  className={`flex items-center gap-3 bg-background border-2 border-primary/50 rounded-lg px-4 py-3 transition-all duration-500 shadow-sm ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                  style={{ transitionDelay: `${500 + index * 100}ms` }}
                >
                  <CheckCircle className="w-6 h-6 text-primary fill-primary/20 flex-shrink-0" strokeWidth={2.5} />
                  <p className="text-foreground text-sm md:text-base font-bold">{text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TransparencySection;
